import BadgeService from "@/services/badge.service.js";
import BadgeFormatter from "@/helpers/formatters/badge.formatter.js";

class BadgeRepository {

    async getBadges() {
        const res = await BadgeService.getBadges();
        return BadgeFormatter.badgesFormat(res.data);
    }

    async getBadgeDetails(id) {
        const res = await BadgeService.getBadgeDetails(id);
        return BadgeFormatter.badgeFormat(res.data);
    }

    async patchBadge(id, data) {
        return await BadgeService.patchBadge(id, {
            ref: data.ref,
            status: data.status
        });
    }

    async addBadgeBalise(badgeId, baliseId) {
        return BadgeService.addBadgeBalise(badgeId, baliseId);
    }

    async removeBadgeBalise(badgeId, baliseId) {
        return BadgeService.removeBadgeBalise(badgeId, baliseId);
    }

    // PROFILES

    async getClientBadgeProfiles() {
        const res = await BadgeService.getClientBadgeProfiles();
        return res.data;
    }

    async getProfile(id) {
        const res = await BadgeService.getProfile(id);
        return res.data;
    }

    async createProfile(name) {
        return await BadgeService.createProfile(name);
    }

    async updateProfile(data) {
        return await BadgeService.updateProfile(data);
    }

    async saveProfileBalises(id, data) {
        return await BadgeService.saveProfileBalises(id, data);
    }

    async deleteProfile(id) {
        return await BadgeService.deleteProfile(id);
    }
}

export default new BadgeRepository();